module.exports = __webpack_public_path__ + "b0b18d9c34c6665f9cc80b4154ba7f77.pdf";